import "react-toastify/dist/ReactToastify.css";
import { TitleWithDivider } from "@common/TitleWithDivider";
import { ConfirmCancelButtons } from "@components/Buttons/ConfirmCancelButtons";
import WarningModal from "@components/Modals/WarningModal";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import LoadingIcon from "@common/LoadingIcon";
import { YobelyGroupInfoCard } from "@pages/YOBELY/common/components/YobelyGroupInfoCard";
import { UseCreateYobelyGroupPage } from "@pages/YOBELY/CreateYobelyGroupPage/hooks/UseCreateYobelyGroupPage";

const CreateYobelyGroupPage: React.FC = () => {
  const form = UseCreateYobelyGroupPage();

  return (
    <div className="container mx-auto p-4">
      <TitleWithDivider
        titleText={
          form.isNotMaster
            ? pageHeaders.YOBELY.groupAdd
            : pageHeaders.YOBELY.groupMasterAdd
        }
        useDivider={true}
      />
      {form.loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-brightness-50 min-h-screen min-w-screen">
          <div className="bg-white bg-opacity-95 p-5 rounded-lg shadow-lg flex items-center justify-center sm:ml-25 lg:ml-50">
            <LoadingIcon />
          </div>
        </div>
      )}
      <div className="flex flex-row justify-end">
        {form.error && (
          <button
            className="button-default"
            type="button"
            onClick={form.handleOpenWarningModal}
          >
            {messages.generic.show_error}
          </button>
        )}
      </div>
      <form
        className="mayo-card-body border border-text-field-border p-4 mt-4"
        onSubmit={form.handleSave}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      >
        <YobelyGroupInfoCard
          broadcastGroup={form.broadcastGroup}
          handleInputChange={form.handleInputChange}
          updateError={form.updateError}
          errors={form.errors}
        />
        <WarningModal
          title={messages.generic.error_modal_title}
          body={form.error}
          confirmText={""}
          cancelText="戻る"
          isOpen={form.warningModalOpen}
          onRequestClose={form.handleCloseWarningModal}
        ></WarningModal>

        <ConfirmCancelButtons
          confirmText={"作成"}
          onCancel={form.onCancel}
          form={true}
        ></ConfirmCancelButtons>
      </form>
    </div>
  );
};

export default CreateYobelyGroupPage;
